import styled, { css } from 'styled-components'

export const TransactionBaseTemplate = styled.div`
  display: flex;

  form {
    width: 100%;
    margin: 0 2rem;
  }

  span:nth-child(2) {
    color: #0e76eb;
  }

  .title {
    padding: 0.25rem;
    text-align: center;
  }

  .blue {
    color: #0e76eb;
  }

  .button {
    text-transform: uppercase;
    margin-left: auto;
    display: flex;
    width: 80px;
    align-items: center;
    justify-content: center;

    &:disabled {
      color: rgba(0, 0, 0, 0.65);
      cursor: not-allowed;
      background: rgba(0, 0, 0, 0.05);
    }

    &:hover {
      background: rgba(0, 0, 0, 0.05);
      color: rgba(0, 0, 0, 0.65);
      color: #40a9ff;
      background-color: #fff;
      border-color: #40a9ff;
      outline: 0;
    }
  }

  .info {
    margin-left: auto;
    color: rgb(100, 101, 103) !important;
  }

  .transaction {
    &__debit {
      background: rgba(221, 106, 105, 0.6) !important;
      font-weight: bold;
    }

    &__deposit {
      background: #add0b3 !important;
      font-weight: bold;
    }
  }
`

export const MultiAdjustmentTemplate = styled(TransactionBaseTemplate)`
  width: 100%;
`

export const TransactionTemplate = styled(TransactionBaseTemplate)`
  width: 80%;
  max-width: 1100px;
  margin: 2em 8em 2em 8em;
`

interface ActionHeaderProps {
  gap?: boolean
}

export const ActionHeader = styled.header<ActionHeaderProps>`
  display: flex;
  justify-content: space-between;
  align-items: center;

  ${(props) =>
    props.gap &&
    css`
      margin-left: -5px;
      margin-right: -5px;

      & > ${HeaderCol} {
        padding-left: 5px;
        padding-right: 5px;
      }
    `};

  button {
    width: auto;
    min-width: 80px;
  }

  .more-button {
    width: 40px !important;
    min-width: 40px !important;
  }

  .is-danger {
    color: #fff;
    background-color: #d9534f;
    border-color: #d43f3a;
    &:hover {
      color: #fff;
      background-color: #c9302c;
      border-color: #ac2925;
    }
  }
`

interface HeaderColProps {
  grow?: boolean
}

export const HeaderCol = styled.div<HeaderColProps>`
  ${(props) =>
    props.grow &&
    css`
      flex-grow: 1;
    `};
`

export const SectionBlock = styled.section`
  display: inline-block;
  flex-direction: column;
  margin: 2em 8px 8px 8px;
  width: 100%;
  border-top: 1px solid var(--foreground);

  > label {
    position: relative;
    left: 5%;
    top: -10px;
    background-color: var(--background);
    font-weight: bold;
    padding: 8px;
  }

  .debit-label {
    color: rgba(221, 106, 105, 0.6);
  }

  .deposit-label {
    color: #add0b3;
  }
`

export const FormFieldBlock = styled.div`
  display: flex;
  flex-direction: column;
  margin: 8px;
  width: 100%;

  input,
  select,
  textarea {
    color: #0e76eb;
    width: 100%;
    border: 1px solid rgba(176, 180, 186, 0.42);
    border-radius: 4px;
    transition: all 0.2s ease;
    background-color: transparent;
    font-size: 14px;
    outline: none;
    resize: none;
    overflow: hidden;
    text-align: left;
    &[type='number'] {
      width: 40%;
    }
    &[type='radio'] {
      width: auto;
    }
    &:disabled {
      cursor: not-allowed;
      color: rgba(0, 0, 0, 0.65);
      background: rgba(0, 0, 0, 0.05);
    }
  }

  textarea {
    overflow: auto;
  }
`
export const NegativeMarginInput = styled.div`
  input,
  select,
  textarea {
    margin-left: 0px !important;
    &:first-child {
      margin-left: -20px !important;
    }
  }
`
export const FormFieldGroup = styled.div`
  display: flex;
  flex-basis: 70%;
  align-items: center;

  input,
  select,
  textarea {
    //margin-left: 8px;
    &:first-child {
      margin-left: 0;
    }
  }
  > a {
    font-weight: bold;
  }
`

export const FormFieldLabel = styled.label`
  width: 30%;
  font-weight: bold;
  color: rgba(0, 0, 0, 0.65);
`

export const FormFieldIconBlock = styled.span`
  margin: 0.2rem 0 0.2rem 0.4rem;
`

export const FormErrorMessage = styled.div`
  width: 100%;
  display: flex;
  color: #f00;
  justify-content: flex-end;
`
export const WalletBlock = styled.div`
  display: flex;
  @media screen and (max-width: 768px) {
    flex-direction: column;
  }
`
